var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSidebarProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6267 5.16683H2.37341M9.66671 7.66683C8.2836 7.66683 6.33337 7.66683 6.33337 7.66683M13.6667 5.50126V12.2502C13.6667 13.0326 13.0324 13.6668 12.25 13.6668H3.75004C2.96764 13.6668 2.33337 13.0326 2.33337 12.2502V5.50126C2.33337 5.28133 2.38458 5.06442 2.48294 4.86771L3.45637 2.92083C3.63635 2.56087 4.00426 2.3335 4.4067 2.3335H11.5934C11.9958 2.3335 12.3637 2.56087 12.5437 2.92083L13.5171 4.86771C13.6155 5.06442 13.6667 5.28133 13.6667 5.50126Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarProduct);
export default __webpack_public_path__ + "static/media/ic-sidebar-product.d0067b2e98c9a22b25395ff9343c8a7b.svg";
export { ForwardRef as ReactComponent };